import { render } from "./YourPlaylist.vue?vue&type=template&id=a8dd35e6&scoped=true&bindings={}"
import script from "./YourPlaylist.vue?vue&type=script&lang=ts"
export * from "./YourPlaylist.vue?vue&type=script&lang=ts"

import "./YourPlaylist.vue?vue&type=style&index=0&id=a8dd35e6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a8dd35e6"

export default script